<template>
    <div class="page-container">
        <div class="container-fluid">
            <!-- Navigation Breadcrumb -->
            <div class="page-navigation">
                <div class="breadcrumb-custom">
                    <router-link to="/">
                        <i class="fas fa-home"></i> Home
                    </router-link>
                    <span class="separator">/</span>
                    <router-link to="/applications">Permohonan</router-link>
                    <span class="separator">/</span>
                    <span>Mohon Ijazah</span>
                </div>
            </div>

            <!-- Page Header -->
            <div class="page-header">
                <h2 class="page-title">Permohonan Ijazah</h2>
                <p class="page-subtitle">Borang Permohonan Penerbitan Ijazah & Transkrip</p>
            </div>

            <!-- Loading State -->
            <div v-if="loading" class="text-center py-5">
                <i class="fas fa-spinner fa-spin fa-2x text-primary"></i>
                <p class="mt-2 text-muted">Memuatkan data...</p>
            </div>

            <!-- Has Pending Request Alert -->
            <!-- <div v-if="hasPendingRequest" class="row justify-content-center">
                <div class="col-12 col-lg-8">
                    <div class="alert-card warning">
                        <div class="alert-icon">
                            <i class="fas fa-clock"></i>
                        </div>
                        <div class="alert-content">
                            <h4>Permohonan Sedang Diproses</h4>
                            <p>Anda memiliki permohonan ijazah yang sedang dalam proses verifikasi.</p>
                            <p><strong>Kode Permohonan:</strong> {{ pendingRequest.request_code }}</p>
                            <p><strong>Tanggal Ajukan:</strong> {{ pendingRequest.request_date }}</p>
                        </div>
                        <button v-if="pendingRequestId" @click="goToStatus(pendingRequestId)" class="btn-primary-custom mt-3">
                            <i class="fas fa-eye"></i> Lihat Status Permohonan
                        </button>
                    </div>
                </div>
            </div> -->

            <!-- Existing Requests Section -->
            <div v-if="existingRequests.length > 0" class="row justify-content-center mb-4">
                <div class="col-12 col-lg-8">
                    <div class="form-card">
                        <div class="card-header-custom">
                            <h5><i class="fas fa-history"></i> Permohonan Sebelumnya</h5>
                            <p class="card-subtitle">Senarai semua permohonan ijazah yang telah dipohon</p>
                        </div>
                        <div class="card-body-custom">
                            <div class="requests-list">
                                <div v-for="req in existingRequests" :key="req.id" class="request-item">
                                    <div class="request-info">
                                        <div class="request-code">{{ req.request_code }}</div>
                                        <div class="request-meta">
                                            <span class="degree-badge">{{ getDegreeLabel(req.degree_level) }}</span>
                                            <span class="request-date">{{ req.request_date }}</span>
                                        </div>
                                    </div>
                                    <div class="request-actions">
                                        <span class="status-badge" :class="getStatusClass(req.status)">
                                            {{ getStatusLabel(req.status) }}
                                        </span>
                                        <button @click="goToStatus(req.id)" class="btn-view-status">
                                            <i class="fas fa-eye"></i> Lihat
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Form Content -->
            <!-- <div v-if="!hasPendingRequest" class="row justify-content-center"> -->
            <div class="row justify-content-center">
                <div class="col-12 col-lg-8">
                    
                    <!-- Student Info Card -->
                    <div class="form-card mb-4">
                        <div class="card-header-custom d-flex justify-content-between align-items-center">
                            <h5><i class="fas fa-user"></i> Maklumat Pelajar</h5>
                            <router-link to="/profile" class="btn-edit-toggle">
                                <i class="fas fa-edit"></i> Edit di Profil
                            </router-link>
                        </div>
                        <div class="card-body-custom">
                            <div class="row">
                                <!-- Nama Arab -->
                                <div class="col-12 col-md-4 mb-3">
                                    <label class="form-label">Nama (Arab/Jawi)</label>
                                    <p class="form-value" dir="rtl">{{ getNestedValue(studentData, 'names.jawi.full_name') || '-' }}</p>
                                </div>
                                <!-- Nama English -->
                                <div class="col-12 col-md-4 mb-3">
                                    <label class="form-label">Nama (English)</label>
                                    <p class="form-value">{{ getNestedValue(studentData, 'names.english.full_name') || '-' }}</p>
                                </div>
                                <!-- Nama Thai -->
                                <div class="col-12 col-md-4 mb-3">
                                    <label class="form-label">Nama (Thai)</label>
                                    <p class="form-value">{{ getNestedValue(studentData, 'names.thai.full_name') || '-' }}</p>
                                </div>
                                <!-- Tarikh Lahir -->
                                <div class="col-12 col-md-4 mb-3">
                                    <label class="form-label">Tarikh Lahir</label>
                                    <p class="form-value">{{ studentData.birth_date || '-' }}</p>
                                </div>
                                <!-- No. Kad Pengenalan -->
                                <div class="col-12 col-md-4 mb-3">
                                    <label class="form-label">No. Kad Pengenalan</label>
                                    <p class="form-value">{{ studentData.citizen_id || '-' }}</p>
                                </div>
                                <!-- No. Telefon -->
                                <div class="col-12 col-md-4 mb-3">
                                    <label class="form-label">No. Telefon</label>
                                    <p class="form-value">{{ studentData.telephone || '-' }}</p>
                                </div>
                                <!-- Email -->
                                <div class="col-12 col-md-6 mb-3">
                                    <label class="form-label">Email</label>
                                    <p class="form-value">{{ studentData.email || '-' }}</p>
                                </div>
                                <!-- Alamat -->
                                <div class="col-12 col-md-6 mb-3">
                                    <label class="form-label">Alamat</label>
                                    <p class="form-value">{{ getNestedValue(studentData, 'address.full_address') || '-' }}</p>
                                </div>
                            </div>
                            
                            <!-- Important Notice -->
                            <div class="alert alert-warning mt-3 mb-2">
                                <i class="fas fa-exclamation-triangle mr-2"></i>
                                <strong>Perhatian!</strong> Sila pastikan semua maklumat profil anda adalah tepat dan lengkap sebelum membuat permohonan ijazah. 
                                Data yang dipaparkan di atas akan digunakan dalam dokumen rasmi anda.
                            </div>
                            
                            <p class="text-muted small mt-2">
                                <i class="fas fa-info-circle"></i> 
                                Untuk mengubah data, sila layari halaman <router-link to="/profile">Profil</router-link>
                            </p>
                        </div>
                    </div>

                    <!-- Form Permohonan -->
                    <form @submit.prevent="submitRequest">
                        <!-- Degree Level Selection -->
                        <div class="form-card mb-4">
                            <div class="card-header-custom">
                                <h5><i class="fas fa-graduation-cap"></i> Peringkat Ijazah</h5>
                            </div>
                            <div class="card-body-custom">
                                <div class="degree-options">
                                    <label class="degree-option" :class="{active: form.degree_level === 'bachelor'}">
                                        <input type="radio" v-model="form.degree_level" value="bachelor">
                                        <div class="degree-content">
                                            <i class="fas fa-user-graduate"></i>
                                            <span>Sarjana (S1)</span>
                                        </div>
                                    </label>
                                    <label class="degree-option" :class="{active: form.degree_level === 'diploma'}">
                                        <input type="radio" v-model="form.degree_level" value="diploma">
                                        <div class="degree-content">
                                            <i class="fas fa-certificate"></i>
                                            <span>Diploma</span>
                                        </div>
                                    </label>
                                </div>
                                <div v-if="errors.degree_level" class="text-danger small mt-2">{{ errors.degree_level[0] }}</div>
                            </div>
                        </div>


                        <!-- Thesis Title and File (for Bachelor) -->
                        <div v-if="form.degree_level === 'bachelor'" class="form-card mb-4">
                            <div class="card-header-custom">
                                <h5><i class="fas fa-book"></i> Data Skripsi \ بحث</h5>
                                <p class="card-subtitle">Wajib diisi untuk peringkat Sarjana Muda</p>
                            </div>
                            <div class="card-body-custom">
                                <!-- Thesis Title Malay -->
                                <div class="form-group mb-3">
                                    <label class="form-label-custom">Tajuk Tesis (Melayu)</label>
                                    <textarea 
                                        v-model="form.thesis_title_malay" 
                                        class="form-control" 
                                        rows="2" 
                                        placeholder="Masukkan tajuk tesis dalam Bahasa Melayu"
                                        maxlength="1000"
                                        :class="{'is-invalid': errors.thesis_title_malay}"
                                    ></textarea>
                                    <div v-if="errors.thesis_title_malay" class="text-danger small mt-1">
                                        {{ errors.thesis_title_malay[0] }}
                                    </div>
                                    <small class="text-muted">{{ form.thesis_title_malay.length }}/1000 karakter</small>
                                </div>

                                <!-- Thesis Title English -->
                                <div class="form-group mb-3">
                                    <label class="form-label-custom">Tajuk Tesis (English)</label>
                                    <textarea 
                                        v-model="form.thesis_title_english" 
                                        class="form-control" 
                                        rows="2" 
                                        placeholder="Enter thesis title in English"
                                        maxlength="1000"
                                        :class="{'is-invalid': errors.thesis_title_english}"
                                    ></textarea>
                                    <div v-if="errors.thesis_title_english" class="text-danger small mt-1">
                                        {{ errors.thesis_title_english[0] }}
                                    </div>
                                    <small class="text-muted">{{ form.thesis_title_english.length }}/1000 karakter</small>
                                </div>

                                <!-- Thesis Title Arab -->
                                <div class="form-group mb-3">
                                    <label class="form-label-custom">Tajuk Tesis (عربي) \ موضوع البحث</label>
                                    <textarea 
                                        v-model="form.thesis_title_arab" 
                                        class="form-control" 
                                        rows="2" 
                                        dir="rtl"
                                        placeholder="موضوع البحث"
                                        maxlength="1000"
                                        :class="{'is-invalid': errors.thesis_title_arab}"
                                    ></textarea>
                                    <div v-if="errors.thesis_title_arab" class="text-danger small mt-1">
                                        {{ errors.thesis_title_arab[0] }}
                                    </div>
                                    <small class="text-muted">{{ form.thesis_title_arab.length }}/1000 karakter</small>
                                </div>

                                <!-- Thesis Title Thai -->
                                <div class="form-group mb-3">
                                    <label class="form-label-custom">Tajuk Tesis (ไทย)</label>
                                    <textarea 
                                        v-model="form.thesis_title_thai" 
                                        class="form-control" 
                                        rows="2" 
                                        placeholder="ป้อนชื่อวิทยานิพนธ์เป็นภาษาไทย"
                                        maxlength="1000"
                                        :class="{'is-invalid': errors.thesis_title_thai}"
                                    ></textarea>
                                    <div v-if="errors.thesis_title_thai" class="text-danger small mt-1">
                                        {{ errors.thesis_title_thai[0] }}
                                    </div>
                                    <small class="text-muted">{{ form.thesis_title_thai.length }}/1000 karakter</small>
                                </div>

                                <!-- Thesis File -->
                                <div class="form-group">
                                    <label class="form-label-custom">Fail Tesis (PDF) <span class="text-muted">(Pilihan)</span></label>
                                    <input 
                                        type="file" 
                                        class="form-control" 
                                        @change="handleThesisFile"
                                        accept=".pdf"
                                        :class="{'is-invalid': errors.thesis_file}"
                                    >
                                    <div v-if="errors.thesis_file" class="text-danger small mt-1">
                                        {{ errors.thesis_file[0] }}
                                    </div>
                                    <small class="text-muted">Format: PDF, Maksimum 10MB</small>
                                </div>
                            </div>
                        </div>

                        <!-- Document Selection -->
                        <div class="form-card mb-4">
                            <div class="card-header-custom">
                                <h5><i class="fas fa-file-alt"></i> Dokumen Yang Dipohon</h5>
                                <p class="card-subtitle">Pilih dokumen yang ingin dipohon</p>
                            </div>
                            <div class="card-body-custom">
                                <!-- Surat Jaminan Kelulusan -->
                                <div class="doc-section" v-if="false">
                                    <h6 class="doc-section-title">Surat Jaminan Kelulusan</h6>
                                    <div class="doc-options">
                                        <label class="doc-checkbox" v-if="form.degree_level === 'diploma'">
                                            <input type="checkbox" v-model="form.doc_guarantee_diploma">
                                            <span class="checkmark"></span>
                                            <span class="doc-label">Diploma</span>
                                        </label>
                                        <label class="doc-checkbox" v-if="form.degree_level === 'bachelor'">
                                            <input type="checkbox" v-model="form.doc_guarantee_bachelor">
                                            <span class="checkmark"></span>
                                            <span class="doc-label">Sarjana</span>
                                        </label>
                                    </div>
                                </div>

                                <!-- Syahadah (Ijazah) -->
                                <div class="doc-section">
                                    <h6 class="doc-section-title">Syahadah (Ijazah)</h6>
                                    <div class="doc-options">
                                        <label class="doc-checkbox" v-if="showArabDoc">
                                            <input type="checkbox" v-model="form.doc_cert_arab">
                                            <span class="checkmark"></span>
                                            <span class="doc-label">Arab</span>
                                        </label>
                                        <label class="doc-checkbox" v-if="false">
                                            <input type="checkbox" v-model="form.doc_cert_english">
                                            <span class="checkmark"></span>
                                            <span class="doc-label">English</span>
                                        </label>
                                        <label class="doc-checkbox">
                                            <input type="checkbox" v-model="form.doc_cert_thai">
                                            <span class="checkmark"></span>
                                            <span class="doc-label">Thai</span>
                                        </label>
                                        <label class="doc-checkbox" v-if="showMalayDoc">
                                            <input type="checkbox" v-model="form.doc_cert_malay">
                                            <span class="checkmark"></span>
                                            <span class="doc-label">Melayu</span>
                                        </label>
                                    </div>
                                </div>

                                <!-- Transkrip Nilai -->
                                <div class="doc-section">
                                    <h6 class="doc-section-title">Transkrip Nilai</h6>
                                    <div class="doc-options">
                                        <label class="doc-checkbox" v-if="showArabDoc">
                                            <input type="checkbox" v-model="form.doc_transcript_arab">
                                            <span class="checkmark"></span>
                                            <span class="doc-label">Arab</span>
                                        </label>
                                        <label class="doc-checkbox" v-if="false">
                                            <input type="checkbox" v-model="form.doc_transcript_english">
                                            <span class="checkmark"></span>
                                            <span class="doc-label">English</span>
                                        </label>
                                        <label class="doc-checkbox">
                                            <input type="checkbox" v-model="form.doc_transcript_thai">
                                            <span class="checkmark"></span>
                                            <span class="doc-label">Thai</span>
                                        </label>
                                        <label class="doc-checkbox" v-if="showMalayDoc">
                                            <input type="checkbox" v-model="form.doc_transcript_malay">
                                            <span class="checkmark"></span>
                                            <span class="doc-label">Melayu</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Supporting Documents -->
                        <div class="form-card mb-4">
                            <div class="card-header-custom">
                                <h5><i class="fas fa-paperclip"></i> Dokumen Pendukung</h5>
                                <p class="card-subtitle">Dokumen yang sudah dimuat naik sebelumnya</p>
                            </div>
                            <div class="card-body-custom">
                                <div class="support-docs-list">
                                    <!-- KAD Pengenalan -->
                                    <div class="support-doc-item">
                                        <div class="doc-status" :class="hasDocument('kad_pengenalan') ? 'uploaded' : 'missing'">
                                            <i :class="hasDocument('kad_pengenalan') ? 'fas fa-check-circle' : 'fas fa-times-circle'"></i>
                                            <span>Salinan KAD Pengenalan</span>
                                        </div>
                                        <button 
                                            v-if="hasDocument('kad_pengenalan')" 
                                            @click="previewDocument('kad_pengenalan')" 
                                            class="btn-preview-doc"
                                            type="button"
                                        >
                                            <i class="fas fa-external-link-alt"></i> Lihat
                                        </button>
                                    </div>
                                    <!-- Syahadah Sanawi -->
                                    <div class="support-doc-item">
                                        <div class="doc-status" :class="hasDocument('syahadah') ? 'uploaded' : 'missing'">
                                            <i :class="hasDocument('syahadah') ? 'fas fa-check-circle' : 'fas fa-times-circle'"></i>
                                            <span>Salinan Syahadah Sanawi</span>
                                        </div>
                                        <button 
                                            v-if="hasDocument('syahadah')" 
                                            @click="previewDocument('syahadah')" 
                                            class="btn-preview-doc"
                                            type="button"
                                        >
                                            <i class="fas fa-external-link-alt"></i> Lihat
                                        </button>
                                    </div>
                                    <!-- Passport -->
                                    <div class="support-doc-item">
                                        <div class="doc-status" :class="hasDocument('passport') ? 'uploaded' : 'missing'">
                                            <i :class="hasDocument('passport') ? 'fas fa-check-circle' : 'fas fa-times-circle'"></i>
                                            <span>Salinan Passport</span>
                                        </div>
                                        <button 
                                            v-if="hasDocument('passport')" 
                                            @click="previewDocument('passport')" 
                                            class="btn-preview-doc"
                                            type="button"
                                        >
                                            <i class="fas fa-external-link-alt"></i> Lihat
                                        </button>
                                    </div>
                                </div>
                                <p class="text-muted small mt-3">
                                    <i class="fas fa-info-circle"></i> 
                                    Muat naik dokumen sokongan di halaman <router-link to="/profile">Profil</router-link>
                                </p>
                            </div>
                        </div>

                        <!-- Notes -->
                        <div class="form-card mb-4">
                            <div class="card-header-custom">
                                <h5><i class="fas fa-sticky-note"></i> Catatan (Opsional)</h5>
                            </div>
                            <div class="card-body-custom">
                                <textarea 
                                    v-model="form.notes" 
                                    class="form-control" 
                                    rows="3" 
                                    placeholder="Tambahkan catatan jika diperlukan..."
                                    maxlength="500"
                                ></textarea>
                                <small class="text-muted">{{ form.notes.length }}/500 karakter</small>
                            </div>
                        </div>

                        <!-- Error Message -->
                        <div v-if="errorMessage" class="alert alert-danger mb-4">
                            <i class="fas fa-exclamation-triangle"></i> {{ errorMessage }}
                        </div>

                        <!-- Submit Button -->
                        <div class="form-actions">
                            <router-link to="/applications" class="btn-secondary-custom">
                                <i class="fas fa-arrow-left"></i> Kembali
                            </router-link>
                            <button type="submit" class="btn-primary-custom" :disabled="submitting">
                                <i v-if="submitting" class="fas fa-spinner fa-spin"></i>
                                <i v-else class="fas fa-paper-plane"></i>
                                {{ submitting ? 'Memohon...' : 'Hantar Permohonan' }}
                            </button>
                        </div>
                    </form>

                </div>
            </div>
        </div>

        <!-- Success Modal -->
        <div class="modal fade modal-theme" id="success-modal" data-backdrop="static" data-keyboard="false" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-body text-center py-5">
                        <div class="success-icon">
                            <i class="fas fa-check-circle"></i>
                        </div>
                        <h4 class="mt-4">Permohonan Berhasil Diajukan!</h4>
                        <p class="text-muted">Kode Permohonan: <strong>{{ successData.request_code }}</strong></p>
                        <p class="text-muted small">Anda dapat melacak status permohonan di halaman Status Permohonan</p>
                        <div class="mt-4">
                            <button v-if="successDataId" @click="goToStatus(successDataId)" class="btn-primary-custom">
                                <i class="fas fa-eye"></i> Lihat Status
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Enhanced Lightbox Preview with Zoom & Pan -->
        <div 
            v-if="showPreview" 
            class="lightbox-overlay" 
            @click.self="closePreview"
            @wheel.prevent="handleLightboxWheel"
        >
            <!-- Close Button -->
            <button class="lightbox-close" @click="closePreview">
                <i class="fas fa-times"></i>
            </button>
            
            <!-- Toolbar -->
            <div class="lightbox-toolbar">
                <span class="lightbox-title">{{ previewTitle }}</span>
                <div class="zoom-controls">
                    <button type="button" class="btn-zoom" @click="zoomOut" :disabled="lightbox.zoom <= 0.5">
                        <i class="fas fa-search-minus"></i>
                    </button>
                    <button 
                        type="button" 
                        class="btn-zoom zoom-level-btn" 
                        @click="resetZoom"
                        title="Reset Zoom"
                    >
                        {{ Math.round(lightbox.zoom * 100) }}%
                    </button>
                    <button type="button" class="btn-zoom" @click="zoomIn" :disabled="lightbox.zoom >= 5">
                        <i class="fas fa-search-plus"></i>
                    </button>
                    <a :href="previewUrl" target="_blank" class="btn-zoom" title="Buka di Tab Baru">
                        <i class="fas fa-external-link-alt"></i>
                    </a>
                </div>
            </div>
            
            <!-- Zoom hint -->
            <p class="lightbox-hint">Double-klik atau scroll untuk zoom • Drag untuk geser</p>
            
            <!-- Image Container with Drag Support -->
            <div 
                class="lightbox-content"
                :class="{ 'cursor-grab': lightbox.zoom > 1, 'cursor-grabbing': lightbox.isDragging }"
                @mousedown="startDrag"
                @mousemove="onDrag"
                @mouseup="endDrag"
                @mouseleave="endDrag"
                @touchstart.prevent="handleTouchStart"
                @touchmove.prevent="handleTouchMove"
                @touchend="handleTouchEnd"
            >
                <img 
                    :src="previewUrl" 
                    class="lightbox-image"
                    alt="Preview Dokumen"
                    :style="lightboxImageStyle"
                    @dblclick="handleDoubleClick"
                    draggable="false"
                >
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import http from '@/services/BackendService'

export default {
    name: 'ApplicationCertificate',
    metaInfo: {
        title: 'Mohon Ijazah'
    },
    data() {
        return {
            loading: true,
            submitting: false,
            hasPendingRequest: false,
            pendingRequest: null,
            studentData: {},
            existingRequests: [],
            form: {
                degree_level: 'bachelor',
                thesis_title_malay: '',
                thesis_title_english: '',
                thesis_title_arab: '',
                thesis_title_thai: '',
                thesis_file: null,
                doc_guarantee_diploma: false,
                doc_guarantee_bachelor: false,
                doc_cert_arab: false,
                doc_cert_english: false,
                doc_cert_thai: false,
                doc_cert_malay: false,
                doc_transcript_arab: false,
                doc_transcript_english: false,
                doc_transcript_thai: false,
                doc_transcript_malay: false,
                notes: ''
            },
            errors: {},
            errorMessage: '',
            successData: {},
            documentBaseUrl: 'https://kisda.online/photo/studentEvedence/confirmed/',
            // Document preview - Enhanced lightbox state
            showPreview: false,
            previewUrl: '',
            previewTitle: '',
            lightbox: {
                zoom: 1,
                translateX: 0,
                translateY: 0,
                isDragging: false,
                startX: 0,
                startY: 0
            },
            lastTouchDistance: null
        }
    },
    computed: {
        // Faculty 121 & 125 issue cert/transcript in Thai + Melayu; others in Thai + Arab
        showMalayDoc() {
            return [121, 125].includes(Number(this.studentData.ft_id))
        },
        showArabDoc() {
            return !this.showMalayDoc
        },
        pendingRequestId() {
            return this.pendingRequest && this.pendingRequest.id ? this.pendingRequest.id : null
        },
        successDataId() {
            return this.successData && this.successData.id ? this.successData.id : null
        },
        lightboxImageStyle() {
            return {
                transform: `scale(${this.lightbox.zoom}) translate(${this.lightbox.translateX}px, ${this.lightbox.translateY}px)`,
                transition: this.lightbox.isDragging ? 'none' : 'transform 0.1s ease'
            }
        }
    },
    mounted() {
        this.loadFormData()
        this.loadExistingRequests()
        window.addEventListener('keyup', this.handleEscKey)
    },
    beforeUnmount() {
        window.removeEventListener('keyup', this.handleEscKey)
    },
    methods: {
        loadFormData() {
            this.loading = true
            this.$Progress.start()
            
            http.get('graduation/formData')
                .then(response => {
                    if (response.data.success) {
                        this.studentData = response.data.data.student
                        this.hasPendingRequest = response.data.data.has_pending_request
                        this.pendingRequest = response.data.data.pending_request
                    }
                    this.loading = false
                    this.$Progress.finish()
                })
                .catch(error => {
                    this.loading = false
                    this.$Progress.fail()
                    if (error.response && (error.response.status == 401 || error.response.status == 419)) {
                        this.$store.dispatch("authentication/cencelAuthen")
                    } else {
                        this.errorMessage = 'Gagal memuat data. Silakan coba lagi.'
                    }
                })
        },
        submitRequest() {
            // Build documents array from checkbox form values
            const documents = [];
            
            // Guarantee documents (based on degree level)
            if (this.form.doc_guarantee_diploma && this.form.degree_level === 'diploma') {
                documents.push({ document_type: 'guarantee', level: 'diploma' });
            }
            if (this.form.doc_guarantee_bachelor && this.form.degree_level === 'bachelor') {
                documents.push({ document_type: 'guarantee', level: 'bachelor' });
            }
            
            // Certificate documents (Syahadah)
            if (this.form.doc_cert_arab) {
                documents.push({ document_type: 'cert', language: 'arab' });
            }
            if (this.form.doc_cert_english) {
                documents.push({ document_type: 'cert', language: 'english' });
            }
            if (this.form.doc_cert_thai) {
                documents.push({ document_type: 'cert', language: 'thai' });
            }
            if (this.form.doc_cert_malay) {
                documents.push({ document_type: 'cert', language: 'malay' });
            }
            
            // Transcript documents
            if (this.form.doc_transcript_arab) {
                documents.push({ document_type: 'transcript', language: 'arab' });
            }
            if (this.form.doc_transcript_english) {
                documents.push({ document_type: 'transcript', language: 'english' });
            }
            if (this.form.doc_transcript_thai) {
                documents.push({ document_type: 'transcript', language: 'thai' });
            }
            if (this.form.doc_transcript_malay) {
                documents.push({ document_type: 'transcript', language: 'malay' });
            }

            // Validate at least one document is selected
            if (documents.length === 0) {
                this.errorMessage = 'Pilih minimal satu dokumen yang dimohon'
                return
            }

            this.submitting = true
            this.errorMessage = ''
            this.errors = {}
            this.$Progress.start()

            // Use FormData for file upload
            const formData = new FormData()
            formData.append('degree_level', this.form.degree_level)
            formData.append('notes', this.form.notes)
            
            // Add thesis data for bachelor
            if (this.form.degree_level === 'bachelor') {
                formData.append('thesis_title_malay', this.form.thesis_title_malay)
                formData.append('thesis_title_english', this.form.thesis_title_english)
                formData.append('thesis_title_arab', this.form.thesis_title_arab)
                formData.append('thesis_title_thai', this.form.thesis_title_thai)
                if (this.form.thesis_file) {
                    formData.append('thesis_file', this.form.thesis_file)
                }
            }
            
            // Add documents as JSON array
            documents.forEach((doc, index) => {
                formData.append(`documents[${index}][document_type]`, doc.document_type)
                if (doc.language) formData.append(`documents[${index}][language]`, doc.language)
                if (doc.level) formData.append(`documents[${index}][level]`, doc.level)
            })

            http.post('graduation/requests', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
                .then(response => {
                    this.submitting = false
                    this.$Progress.finish()
                    
                    if (response.data.success) {
                        this.successData = response.data.data
                        $("#success-modal").modal("show")
                        // Reload existing requests list
                        this.loadExistingRequests()
                        // Reset form
                        this.form.thesis_title_malay = ''
                        this.form.thesis_title_english = ''
                        this.form.thesis_title_arab = ''
                        this.form.thesis_title_thai = ''
                        this.form.thesis_file = null
                    }
                })
                .catch(error => {
                    this.submitting = false
                    this.$Progress.fail()
                    
                    if (error.response) {
                        if (error.response.status == 422) {
                            this.errors = error.response.data.errors || {}
                            this.errorMessage = error.response.data.message || 'Validasi gagal'
                        } else if (error.response.status == 401 || error.response.status == 419) {
                            this.$store.dispatch("authentication/cencelAuthen")
                        } else {
                            this.errorMessage = error.response.data.message || 'Terjadi kesalahan'
                        }
                    } else {
                        this.errorMessage = 'Gagal menghubungi server'
                    }
                })
        },
        loadExistingRequests() {
            http.get('graduation/requests')
                .then(response => {
                    if (response.data.success) {
                        this.existingRequests = response.data.data
                    }
                })
                .catch(() => {
                    // Silently fail - not critical for page load
                })
        },
        handleThesisFile(e) {
            this.form.thesis_file = e.target.files[0] || null
        },
        getNestedValue(obj, path) {
            return path.split('.').reduce((current, key) => current && current[key] !== undefined ? current[key] : null, obj)
        },
        hasDocument(docType) {
            return this.studentData && this.studentData.documents && this.studentData.documents[docType]
        },
        getDocumentUrl(docType) {
            if (!this.hasDocument(docType)) return null
            return this.documentBaseUrl + this.studentData.documents[docType]
        },
        previewDocument(docType) {
            const url = this.getDocumentUrl(docType)
            if (url) {
                // Set preview data
                this.previewUrl = url
                
                // Set title based on document type
                const titles = {
                    'kad_pengenalan': 'Salinan KAD Pengenalan',
                    'syahadah': 'Salinan Syahadah Sanawi',
                    'passport': 'Salinan Passport'
                }
                this.previewTitle = titles[docType] || 'Dokumen'
                
                // Reset lightbox state
                this.lightbox.zoom = 1
                this.lightbox.translateX = 0
                this.lightbox.translateY = 0
                this.lightbox.isDragging = false
                
                // Show lightbox
                this.showPreview = true
                // Prevent body scroll
                document.body.style.overflow = 'hidden'
            }
        },
        closePreview() {
            this.showPreview = false
            // Restore body scroll
            document.body.style.overflow = ''
        },
        // Zoom controls
        zoomIn() {
            if (this.lightbox.zoom < 5) {
                this.lightbox.zoom = Math.min(5, this.lightbox.zoom + 0.5)
            }
        },
        zoomOut() {
            if (this.lightbox.zoom > 0.5) {
                this.lightbox.zoom = Math.max(0.5, this.lightbox.zoom - 0.5)
                // Reset position if zoom is back to 1 or less
                if (this.lightbox.zoom <= 1) {
                    this.lightbox.translateX = 0
                    this.lightbox.translateY = 0
                }
            }
        },
        resetZoom() {
            this.lightbox.zoom = 1
            this.lightbox.translateX = 0
            this.lightbox.translateY = 0
        },
        // Double-click zoom toggle
        handleDoubleClick() {
            if (this.lightbox.zoom === 1) {
                this.lightbox.zoom = 2
            } else {
                this.resetZoom()
            }
        },
        // Mouse wheel zoom
        handleLightboxWheel(event) {
            const delta = event.deltaY > 0 ? -0.25 : 0.25
            const newZoom = Math.max(0.5, Math.min(5, this.lightbox.zoom + delta))
            
            if (newZoom !== this.lightbox.zoom) {
                this.lightbox.zoom = newZoom
                // Reset position if zoom is 1 or less
                if (newZoom <= 1) {
                    this.lightbox.translateX = 0
                    this.lightbox.translateY = 0
                }
            }
        },
        // Drag/Pan functions
        startDrag(event) {
            if (this.lightbox.zoom <= 1) return
            this.lightbox.isDragging = true
            this.lightbox.startX = event.clientX - this.lightbox.translateX
            this.lightbox.startY = event.clientY - this.lightbox.translateY
        },
        onDrag(event) {
            if (!this.lightbox.isDragging || this.lightbox.zoom <= 1) return
            this.lightbox.translateX = event.clientX - this.lightbox.startX
            this.lightbox.translateY = event.clientY - this.lightbox.startY
        },
        endDrag() {
            this.lightbox.isDragging = false
        },
        // Touch support for mobile
        handleTouchStart(event) {
            if (event.touches.length === 1 && this.lightbox.zoom > 1) {
                // Single finger drag
                this.lightbox.isDragging = true
                this.lightbox.startX = event.touches[0].clientX - this.lightbox.translateX
                this.lightbox.startY = event.touches[0].clientY - this.lightbox.translateY
            } else if (event.touches.length === 2) {
                // Two finger pinch-to-zoom
                this.lightbox.isDragging = false
                this.lastTouchDistance = this.getTouchDistance(event.touches)
            }
        },
        handleTouchMove(event) {
            if (event.touches.length === 1 && this.lightbox.isDragging && this.lightbox.zoom > 1) {
                // Single finger drag
                this.lightbox.translateX = event.touches[0].clientX - this.lightbox.startX
                this.lightbox.translateY = event.touches[0].clientY - this.lightbox.startY
            } else if (event.touches.length === 2) {
                // Pinch-to-zoom
                const currentDistance = this.getTouchDistance(event.touches)
                if (this.lastTouchDistance) {
                    const scale = currentDistance / this.lastTouchDistance
                    const newZoom = Math.max(0.5, Math.min(5, this.lightbox.zoom * scale))
                    this.lightbox.zoom = newZoom
                    
                    if (newZoom <= 1) {
                        this.lightbox.translateX = 0
                        this.lightbox.translateY = 0
                    }
                }
                this.lastTouchDistance = currentDistance
            }
        },
        handleTouchEnd() {
            this.lightbox.isDragging = false
            this.lastTouchDistance = null
        },
        getTouchDistance(touches) {
            const dx = touches[0].clientX - touches[1].clientX
            const dy = touches[0].clientY - touches[1].clientY
            return Math.sqrt(dx * dx + dy * dy)
        },
        // ESC key handler
        handleEscKey(event) {
            if (event.key === 'Escape' && this.showPreview) {
                this.closePreview()
            }
        },
        getStatusClass(status) {
            const classes = {
                'pending': 'status-pending',
                'approved': 'status-approved',
                'rejected': 'status-rejected',
                'completed': 'status-completed'
            }
            return classes[status] || 'status-pending'
        },
        getStatusLabel(status) {
            const labels = {
                'pending': 'Dalam Proses',
                'approved': 'Diluluskan',
                'rejected': 'Ditolak',
                'completed': 'Selesai'
            }
            return labels[status] || 'Tidak Diketahui'
        },
        getDegreeLabel(level) {
            return level === 'bachelor' ? 'Sarjana (S1)' : 'Diploma'
        },
        goToStatus(id) {
            if (id) {
                $("#success-modal").modal("hide")
                this.$router.push({ name: 'application-certificate-status', params: { id: id } })
            }
        }
    }
}
</script>

<style scoped>
/* Alert Card */
.alert-card {
    background: var(--bg-white, #fff);
    border-radius: var(--border-radius, 12px);
    padding: 30px;
    text-align: center;
    box-shadow: var(--shadow-md, 0 4px 15px rgba(0,0,0,0.1));
}

.alert-card.warning {
    border-left: 4px solid #f39c12;
}

.alert-icon {
    width: 80px;
    height: 80px;
    background: linear-gradient(135deg, #f39c12 0%, #e67e22 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 20px;
}

.alert-icon i {
    font-size: 2rem;
    color: #fff;
}

.alert-content h4 {
    color: var(--text-primary, #2c3e50);
    margin-bottom: 10px;
}

.alert-content p {
    color: var(--text-secondary, #7f8c8d);
    margin-bottom: 5px;
}

/* Form Card - White Background */
.form-card {
    background: var(--bg-white, #fff);
    border-radius: var(--border-radius, 12px);
    box-shadow: var(--shadow-sm, 0 2px 8px rgba(0,0,0,0.1));
    overflow: hidden;
    transition: all 0.3s ease;
    border: 1px solid rgba(0,0,0,0.05);
}

.form-card:hover {
    box-shadow: var(--shadow-md, 0 4px 15px rgba(0,0,0,0.1));
}

/* Card Styles */
.card-header-custom {
    padding: 16px 20px;
    background: var(--primary-gradient, linear-gradient(135deg, #47c07a 0%, #2d9d6f 100%));
    color: #fff;
}

.card-header-custom h5 {
    margin: 0;
    color: #fff;
    font-weight: 600;
}

.card-header-custom h5 i {
    margin-right: 10px;
    color: #fff;
}

/* Edit Button in Header */
.btn-edit-toggle {
    background: rgba(255, 255, 255, 0.2);
    color: #fff;
    border: 1px solid rgba(255, 255, 255, 0.4);
    padding: 6px 14px;
    border-radius: 6px;
    font-size: 0.85rem;
    font-weight: 500;
    text-decoration: none;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.btn-edit-toggle:hover {
    background: rgba(255, 255, 255, 0.3);
    color: #fff;
    text-decoration: none;
}

.card-subtitle {
    font-size: 0.85rem;
    color: rgba(255, 255, 255, 0.8);
    margin: 5px 0 0;
}

.card-body-custom {
    padding: 20px;
}

/* Form Styles */
.form-label {
    font-size: 0.85rem;
    color: var(--text-secondary, #7f8c8d);
    margin-bottom: 5px;
    display: block;
}

.form-value {
    font-size: 1rem;
    color: var(--text-primary, #2c3e50);
    font-weight: 500;
    margin: 0;
}

/* Degree Options */
.degree-options {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
}

.degree-option {
    flex: 1;
    min-width: 150px;
    cursor: pointer;
}

.degree-option input {
    display: none;
}

.degree-content {
    background: #f8f9fa;
    border: 2px solid #e9ecef;
    border-radius: var(--border-radius-sm, 8px);
    padding: 20px;
    text-align: center;
    transition: all 0.3s ease;
}

.degree-option.active .degree-content {
    background: linear-gradient(135deg, rgba(26, 188, 156, 0.1) 0%, rgba(22, 160, 133, 0.1) 100%);
    border-color: var(--primary-color, #1abc9c);
}

.degree-content i {
    font-size: 2rem;
    color: var(--primary-color, #1abc9c);
    margin-bottom: 10px;
    display: block;
}

.degree-content span {
    font-weight: 600;
    color: var(--text-primary, #2c3e50);
}

/* Document Section */
.doc-section {
    margin-bottom: 25px;
}

.doc-section:last-child {
    margin-bottom: 0;
}

.doc-section-title {
    font-size: 0.95rem;
    color: var(--text-primary, #2c3e50);
    font-weight: 600;
    margin-bottom: 15px;
    padding-bottom: 8px;
    border-bottom: 1px dashed #e9ecef;
}

.doc-options {
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
}

/* Custom Checkbox */
.doc-checkbox {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 10px 15px;
    background: #f8f9fa;
    border-radius: var(--border-radius-sm, 8px);
    transition: all 0.3s ease;
}

.doc-checkbox:hover {
    background: #e9ecef;
}

.doc-checkbox input {
    display: none;
}

.doc-checkbox .checkmark {
    width: 22px;
    height: 22px;
    border: 2px solid #ccc;
    border-radius: 4px;
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
}

.doc-checkbox input:checked + .checkmark {
    background: var(--primary-color, #1abc9c);
    border-color: var(--primary-color, #1abc9c);
}

.doc-checkbox input:checked + .checkmark::after {
    content: '\f00c';
    font-family: 'Font Awesome 5 Free';
    font-weight: 900;
    color: #fff;
    font-size: 12px;
}

.doc-label {
    font-weight: 500;
    color: var(--text-primary, #2c3e50);
}

/* Document Status */
.doc-status {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 15px;
    border-radius: var(--border-radius-sm, 8px);
}

.doc-status.uploaded {
    background: rgba(39, 174, 96, 0.1);
    color: #27ae60;
}

.doc-status.missing {
    background: rgba(231, 76, 60, 0.1);
    color: #e74c3c;
}

.doc-status i {
    font-size: 1.2rem;
}

/* Form Actions */
.form-actions {
    display: flex;
    gap: 15px;
    justify-content: flex-end;
    padding: 20px 0;
}

/* Buttons */
.btn-primary-custom {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: linear-gradient(135deg, #1abc9c 0%, #16a085 100%);
    color: #fff;
    padding: 12px 25px;
    border-radius: var(--border-radius-sm, 8px);
    border: none;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;
}

.btn-primary-custom:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(26, 188, 156, 0.4);
    color: #fff;
}

.btn-primary-custom:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
}

.btn-secondary-custom {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: #f8f9fa;
    color: var(--text-secondary, #7f8c8d);
    padding: 12px 25px;
    border-radius: var(--border-radius-sm, 8px);
    border: 1px solid #e9ecef;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;
}

.btn-secondary-custom:hover {
    background: #e9ecef;
    color: var(--text-primary, #2c3e50);
}

/* Success Modal */
.success-icon {
    width: 80px;
    height: 80px;
    background: linear-gradient(135deg, #27ae60 0%, #2ecc71 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
}

.success-icon i {
    font-size: 2.5rem;
    color: #fff;
}

/* Form Control Override */
.form-control {
    border: 1px solid #e9ecef;
    border-radius: var(--border-radius-sm, 8px);
    padding: 12px 15px;
}

.form-control:focus {
    border-color: var(--primary-color, #1abc9c);
    box-shadow: 0 0 0 3px rgba(26, 188, 156, 0.1);
}

/* Responsive */
@media (max-width: 576px) {
    .degree-options {
        flex-direction: column;
    }
    
    .doc-options {
        flex-direction: column;
    }
    
    .form-actions {
        flex-direction: column;
    }
    
    .btn-primary-custom,
    .btn-secondary-custom {
        width: 100%;
        justify-content: center;
    }
    
    .request-item {
        flex-direction: column;
        gap: 10px;
    }
    
    .request-actions {
        width: 100%;
        justify-content: space-between;
    }
    
    .support-doc-item {
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
    }
}

/* Existing Requests List */
.requests-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.request-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    background: #f8f9fa;
    border-radius: var(--border-radius-sm, 8px);
    border-left: 4px solid var(--primary-color, #1abc9c);
    transition: all 0.3s ease;
}

.request-item:hover {
    background: #f0f0f0;
}

.request-info {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.request-code {
    font-weight: 600;
    color: var(--text-primary, #2c3e50);
    font-size: 1rem;
}

.request-meta {
    display: flex;
    gap: 12px;
    font-size: 0.85rem;
    color: var(--text-secondary, #7f8c8d);
}

.degree-badge {
    background: rgba(26, 188, 156, 0.1);
    color: var(--primary-color, #1abc9c);
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 0.8rem;
    font-weight: 500;
}

.request-date {
    color: var(--text-secondary, #7f8c8d);
}

.request-actions {
    display: flex;
    align-items: center;
    gap: 12px;
}

/* Status Badges */
.status-badge {
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 0.8rem;
    font-weight: 600;
    text-transform: uppercase;
}

.status-pending {
    background: rgba(241, 196, 15, 0.15);
    color: #f39c12;
}

.status-approved {
    background: rgba(39, 174, 96, 0.15);
    color: #27ae60;
}

.status-rejected {
    background: rgba(231, 76, 60, 0.15);
    color: #e74c3c;
}

.status-completed {
    background: rgba(52, 152, 219, 0.15);
    color: #3498db;
}

/* View Status Button */
.btn-view-status {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: transparent;
    color: var(--primary-color, #1abc9c);
    border: 1px solid var(--primary-color, #1abc9c);
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 0.85rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
}

.btn-view-status:hover {
    background: var(--primary-color, #1abc9c);
    color: #fff;
}

/* Form Label Custom */
.form-label-custom {
    font-size: 0.9rem;
    font-weight: 600;
    color: var(--text-primary, #2c3e50);
    margin-bottom: 8px;
    display: block;
}

/* Supporting Documents List */
.support-docs-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.support-doc-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 15px;
    background: #f8f9fa;
    border-radius: var(--border-radius-sm, 8px);
}

.support-doc-item .doc-status {
    flex: 1;
}

/* Preview Document Button */
.btn-preview-doc {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: rgba(52, 152, 219, 0.1);
    color: #3498db;
    border: none;
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 0.8rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
}

.btn-preview-doc:hover {
    background: #3498db;
    color: #fff;
}

/* Custom Lightbox */
.lightbox-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.95);
    z-index: 9999;
    display: flex;
    flex-direction: column;
    animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}

.lightbox-close {
    position: absolute;
    top: 15px;
    right: 20px;
    width: 45px;
    height: 45px;
    border-radius: 50%;
    border: none;
    background: rgba(255, 255, 255, 0.15);
    color: #fff;
    font-size: 1.2rem;
    cursor: pointer;
    z-index: 10001;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
}

.lightbox-close:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: scale(1.1);
}

.lightbox-toolbar {
    position: absolute;
    top: 15px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    gap: 15px;
    background: rgba(0, 0, 0, 0.7);
    padding: 10px 20px;
    border-radius: 30px;
    z-index: 10000;
}

.lightbox-title {
    color: #fff;
    font-weight: 600;
    font-size: 0.95rem;
}

.lightbox-hint {
    position: absolute;
    top: 70px;
    left: 50%;
    transform: translateX(-50%);
    color: rgba(255, 255, 255, 0.5);
    font-size: 0.75rem;
    z-index: 10000;
    pointer-events: none;
}

.lightbox-content {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    padding: 90px 20px 20px;
    user-select: none;
}

.lightbox-content.cursor-grab {
    cursor: grab;
}

.lightbox-content.cursor-grabbing {
    cursor: grabbing;
}

.lightbox-image {
    max-width: 95vw;
    max-height: 85vh;
    object-fit: contain;
    display: block;
    transform-origin: center center;
}

/* Zoom Controls */
.zoom-controls {
    display: flex;
    align-items: center;
    gap: 8px;
}

.btn-zoom {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: none;
    background: rgba(255, 255, 255, 0.15);
    color: #fff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    text-decoration: none;
}

.btn-zoom.zoom-level-btn {
    width: auto;
    min-width: 55px;
    padding: 0 10px;
    border-radius: 18px;
    font-size: 0.85rem;
    font-weight: 600;
}

.btn-zoom:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.3);
}

.btn-zoom:disabled {
    opacity: 0.3;
    cursor: not-allowed;
}

/* Responsive lightbox */
@media (max-width: 768px) {
    .lightbox-toolbar {
        flex-direction: column;
        gap: 10px;
        padding: 15px;
        width: calc(100% - 80px);
    }
    
    .lightbox-hint {
        top: auto;
        bottom: 20px;
    }
    
    .lightbox-content {
        padding: 140px 10px 50px;
    }
    
    .lightbox-image {
        max-width: 100%;
        max-height: 70vh;
    }
}
</style>
